/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which reading level should I aim for?`)
};

const es_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿A qué nivel de lectura debo apuntar?`)
};

const de_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Lesestufe sollte ich anstreben?`)
};

const nl_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk leesniveau moet ik nastreven?`)
};

const fr_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel niveau de lecture devrais-je viser ?`)
};

const it_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale livello di lettura dovrei mirare?`)
};

const pt_br2_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para qual nível de leitura devo mirar?`)
};

const pt_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que nível de leitura devo visar?`)
};

const ja_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのレベルの読みやすさを目指すべきですか？`)
};

const zh_ra_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该以哪种阅读难度为目标？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq4_q", locale)
	if (locale === "en") return en_ra_faq4_q(inputs)
	if (locale === "es") return es_ra_faq4_q(inputs)
	if (locale === "de") return de_ra_faq4_q(inputs)
	if (locale === "nl") return nl_ra_faq4_q(inputs)
	if (locale === "fr") return fr_ra_faq4_q(inputs)
	if (locale === "it") return it_ra_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq4_q(inputs)
	if (locale === "pt") return pt_ra_faq4_q(inputs)
	if (locale === "ja") return ja_ra_faq4_q(inputs)
	return zh_ra_faq4_q(inputs)
};